export default "__VITE_ASSET__24582286__"